import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store';
import { selectChartArms } from '@/store/selectors';

/** Compact sparkline of concentration-time curves (F-053). */
export function InlineSparkline() {
  const arms = useStore(useShallow(selectChartArms));
  const W = 280;
  const H = 80;

  const paths = useMemo(() => {
    if (arms.length === 0) return [];
    const allPoints = arms.flatMap((a) => a.points);
    if (allPoints.length === 0) return [];
    const maxT = Math.max(...allPoints.map((p) => p.time), 1);
    const maxC = Math.max(...allPoints.map((p) => p.concentration), 1);

    return arms
      .filter((a) => a.points.length > 0)
      .map((arm) => {
        const d = arm.points
          .map((p, i) => {
            const x = (p.time / maxT) * (W - 10) + 5;
            const y = H - 5 - (p.concentration / maxC) * (H - 10);
            return `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`;
          })
          .join(' ');
        return { color: arm.color, d, label: arm.label };
      });
  }, [arms]);

  if (paths.length === 0) return null;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img" aria-label="Concentration-time sparkline">
      {paths.map((p, i) => (
        <path key={i} d={p.d} fill="none" stroke={p.color} strokeWidth={1.5} />
      ))}
    </svg>
  );
}
